import { MessagePunishAction, PunishActionTypesEnum } from "../..";

export class DeleteMessageAction extends MessagePunishAction {
  type = PunishActionTypesEnum.DeleteMessage

  delete_message_delay!: number
}
